import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import Dialog from 'components/ReusableComponents/Dialog'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import Table, { TitleCell, TitleRow } from 'components/ReusableComponents/Table'
import BookingRow from 'features/BookingHistory/BookingRow'
import useFirstRender from 'hooks/useFirstRender'
import PropTypes from 'prop-types'
import { useState } from 'react'
import dashboardApi from 'services/api/dashboard'

import styles from './BookingHistory.module.scss'
import Header from './Header'

const BookingHistory = ({ bookingId, handleClose, userData }) => {
  const [isLoading, setLoading] = useState(true)
  const [isError, setError] = useState(false)
  const [bookingsData, setBookingsData] = useState(null)

  useFirstRender(() => {
    const getGuestBookings = async id => {
      await dashboardApi
        .getPriorBookings(id)
        .then(data => {
          const priors = data.priors
          setBookingsData(priors)
          setLoading(false)
          setError(false)
        })
        .catch(() => {
          setLoading(false)
          setError(true)
          setBookingsData(null)
        })
    }

    getGuestBookings(bookingId)
  }, [bookingId])

  if (isLoading) {
    return (
      <Dialog>
        <LoadingIndicator />
      </Dialog>
    )
  }

  if (isError) {
    return (
      <ConfirmationDialog onConfirm={handleClose}>
        Something went wrong while getting user data
      </ConfirmationDialog>
    )
  }

  if (!bookingsData) {
    return <div>weird</div>
  }

  return (
    <ConfirmationDialog
      maxWidth={1650}
      hasConfirmButton={false}
      styleOverrides={{ background: '#f7f7f9' }}
      onReject={handleClose}
      title="Prior bookings"
    >
      <div>
        <Header {...userData} />

        <div className={styles.container}>
          <Table
            widths={[
              90, 120, 150, 120, 170, 120, 80, 80, 80, 70, 85, 120, 110, 80, 95, 95
            ]}
          >
            <TitleRow>
              <TitleCell>Booked on</TitleCell>
              <TitleCell>Booked by</TitleCell>
              <TitleCell>Guest name</TitleCell>
              <TitleCell>Phone</TitleCell>
              <TitleCell>Email</TitleCell>
              <TitleCell>City &amp; State</TitleCell>
              <TitleCell>Source</TitleCell>
              <TitleCell>C/I</TitleCell>
              <TitleCell>C/O</TitleCell>
              <TitleCell>Total</TitleCell>
              <TitleCell>Rate code</TitleCell>
              <TitleCell>Tracking</TitleCell>
              <TitleCell>Company</TitleCell>
              <TitleCell>Room</TitleCell>
              <TitleCell>Booking #</TitleCell>
              <TitleCell>Conf #</TitleCell>
            </TitleRow>
            {Object.values(
              bookingsData
                .filter(booking => booking.matchMatchKind !== 'ByPhone')
                .reduce((prev, curr) => {
                  return {
                    ...prev,
                    [curr.bookingId]: curr
                  }
                }, {})
            )
              .sort((a, b) => new Date(b.checkOut) - new Date(a.checkOut))
              .map(booking => (
                <BookingRow key={booking.id} {...booking} />
              ))}
          </Table>
        </div>
      </div>
    </ConfirmationDialog>
  )
}

BookingHistory.propTypes = {
  bookingId: PropTypes.number.isRequired,
  handleClose: PropTypes.func.isRequired,
  userData: PropTypes.object.isRequired
}

export default BookingHistory
